module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./MaterialListSearchView.js"));
	}, "MaterialListSearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MaterialListSearchView!./src/pages/Promote/MaterialCenter/MaterialListSearch/MaterialListSearchView.js
// module id = 1122
// module chunks = 431